import { PermissionType } from "models";

let permissionTranslations: Record<PermissionType, string> = {
    [PermissionType.User]: t('Ankomstregistrerare'),
    [PermissionType.WebUser]: t('Webanvändare'),
    [PermissionType.Attestant]: t('Attestant'),
    [PermissionType.Admin]: t('Administratör'),
  
    [PermissionType.Bokforing]: t('Resultat / balansrapport'),
    [PermissionType.Contracts]: t('Avtal'),
    [PermissionType.FilArkiv]: t('Filarkiv'),
  
    [PermissionType.AktivaFakturor]: t('Aktiva fakturor'),
    [PermissionType.SearchInvoices]: t('Söka fakturor'),
    [PermissionType.Betalningar]: t('Betalningar'),
  
    [PermissionType.ChangeInvoiceInformation]: t('Ändra fakturainfo'),
    [PermissionType.ChangeKontering]: t('Ändra kontering'),
    [PermissionType.BytaAttestkedja]: t('Byta attestkedja'),
  
    [PermissionType.Suppliers]: t('Leverantörer'),
    [PermissionType.Kontoplan]: t('Kontoplan'),
    [PermissionType.Attestkedjemall]: t('Attestkedjemallar'),
    [PermissionType.Kostnadsstallen]: t('Kostnadsställen'),
    [PermissionType.Projekt]: t('Projekt'),
    [PermissionType.Valutor]: t('Valutor'),
  };

export function translateEnum(permission: PermissionType) {
    return permissionTranslations[permission];
}

export function t(key: string) {
    return key;
}
